import authAxios from '../authorization/axios';
import constants from '../constants';

export const initKycAccount = async (mail: string) => {
  const main = constants.api.initKycAccount.replace('{mail}', mail);

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};